import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import TableReview from '../../views/review/TableReview'

const ReviewList = () => {

  return (
    <Page title="리뷰">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  리뷰
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              상품 리뷰 리스트를 보여줍니다.
            </Typography>
          }
        />
        <Grid item xs={12}>
          <TableReview />
        </Grid>
      </Grid>
    </Page>
  )
}

export default ReviewList